import React from 'react';
import styles from './progression-bar.module.css.js';
import { calculatePercentage } from '../../util/numberUtils.js';

function PendingBar({ pendingText, width }) {
    return (React.createElement("div", { "data-testid": 'percentage-pending', className: styles.pending, style: { width } }, pendingText));
}
function ScoreBar({ achievable, achieved, maximum, pending = 0, }) {
    // Safeguard in case of eduhint tests that are not finished yet (eduhint returns achieved -1)
    if (achieved === -1)
        return null;
    const percentageCorrect = calculatePercentage(achieved / maximum);
    const percentagePending = calculatePercentage(pending / maximum);
    const percentageIncorrect = calculatePercentage((achievable - achieved) / maximum);
    return (React.createElement(React.Fragment, null,
        percentageCorrect > 0 && (React.createElement("div", { "data-testid": 'percentage-correct', className: styles.correct, style: { width: `${percentageCorrect}%` } })),
        percentageIncorrect > 0 && (React.createElement("div", { "data-testid": 'percentage-incorrect', className: styles.incorrect, style: { width: `${percentageIncorrect}%` } })),
        percentagePending > 0 && React.createElement(PendingBar, { width: `${percentagePending}%` })));
}
function ProgressionBar({ translations, ...score }) {
    return (React.createElement("div", { className: styles.container, "data-testid": 'progression-bar-container' },
        React.createElement("div", { className: styles['score-wrapper'], "data-testid": 'score-wrapper' }, score.pending === score.maximum ? React.createElement(PendingBar, { pendingText: translations?.pending }) : React.createElement(ScoreBar, { ...score }))));
}

export { ProgressionBar };
